import React from 'react';

interface LoadingOverlayProps {
  isVisible: boolean;
  message?: string;
  showProgress?: boolean;
  progress?: {
    current: number;
    total: number;
  };
  className?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isVisible,
  message = 'Cargando...',
  showProgress = false,
  progress = { current: 0, total: 0 },
  className = '',
}) => {
  if (!isVisible) return null;

  const progressPercentage = progress.total > 0 ? (progress.current / progress.total) * 100 : 0;

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ${className}`}
    >
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full mx-4">
        <div className="flex items-center justify-center mb-4">
          <svg
            className="animate-spin h-8 w-8 text-brand-orange"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>

        <h3 className="text-lg font-semibold text-center text-gray-900 mb-2">{message}</h3>

        {showProgress && progress.total > 0 && (
          <>
            <p className="text-sm text-gray-600 text-center mb-2">
              {progress.current} de {progress.total} elementos procesados
            </p>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div
                className="bg-brand-orange h-2 rounded-full transition-all duration-300"
                style={{ width: `${progressPercentage}%` }}
              ></div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
